import { makeDynamicHelpBlogUrl } from '@dealstack/frontend/app/pages/HelpBlog/help-blog.utils.ts';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.tsx';
import { useParams } from 'react-router-dom';
import { AddBreadcrumbItem } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.types';

export const useHelpBlogBreadcrumbs = (breadcrumbs: AddBreadcrumbItem[]) => {
	const { dealId } = useParams();

	useBreadcrumbs(
		breadcrumbs.map((breadcrumb) => ({
			...breadcrumb,
			url: makeDynamicHelpBlogUrl(dealId, breadcrumb.url),
		})),
		{ skipFirst: true }
	);
};
